<template>
  <div>
    <Modal class="printModal rma-order-print-modal" :value="innerVisible" title="打印不良品处理单" :mask-closable="false" width="900" :closable="false" @on-visible-change="onModalVisibleChange">
      <Spin v-if="loading" fix />
      <div v-else-if="!order" class="rma-print-empty">无打印数据</div>
      <div v-else id="PrintArea">
        <!-- 整张单表 + 固定 7 列 colgroup：避免上下两半竖线错位、双表接缝粗线 -->
        <table class="rma-print-table-root" cellspacing="0" cellpadding="0" width="100%">
          <colgroup>
            <col class="rma-col-g1" />
            <col class="rma-col-g2" />
            <col class="rma-col-g3" />
            <col class="rma-col-g4" />
            <col class="rma-col-g5" />
            <col class="rma-col-g6" />
            <col class="rma-col-g7" />
          </colgroup>
          <tbody>
            <tr>
              <td colspan="7" class="rma-print-cell rma-print-title rma-print-company">长沙金镂机械科技有限公司</td>
            </tr>
            <tr>
              <td colspan="7" class="rma-print-cell rma-print-title">
                表单编号：{{ formTemplateCode }}
              </td>
            </tr>
            <tr>
              <td colspan="3" class="rma-print-cell rma-print-meta">记录编号：{{ disp(order.recordNumber) }}</td>
              <td colspan="4" class="rma-print-cell rma-print-meta">表单编号：{{ disp(order.formNumber) }}</td>
            </tr>
            <!-- <tr>
              <td colspan="7" class="rma-print-cell text-copy-row">
                当前单据为：<span class="chk-w">□</span>第一联
                <span class="chk-w">□</span>第二联
              </td>
            </tr> -->
            <tr>
              <td colspan="2" class="rma-print-cell rma-print-label">事业部</td>
              <td colspan="5" class="rma-print-cell rma-print-value">{{ causeDeptText }}</td>
            </tr>
            <tr>
              <td colspan="2" class="rma-print-cell rma-print-label">客户名称</td>
              <td colspan="5" class="rma-print-cell rma-print-value">{{ disp(order.customerName) }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">物料名称</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.materialName) }}</td>
              <td class="rma-print-cell rma-print-label">规格/型号</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.specificationModel) }}</td>
              <td class="rma-print-cell rma-print-label">图号/客户物料编码</td>
              <td class="rma-print-cell rma-print-value" colspan="2">{{ disp(order.drawingOrCustomerMaterialCode) }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">金蝶代码</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.kingdeeCode) }}</td>
              <td class="rma-print-cell rma-print-label">报告部门</td>
              <td class="rma-print-cell rma-print-value" colspan="4">{{ disp(order.reportingDepartment) }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">发生时间</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.occurrenceTimeText) }}</td>
              <td class="rma-print-cell rma-print-label">责任单位/部门</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.responsibleUnitOrDept) }}</td>
              <td class="rma-print-cell rma-print-label">责任人</td>
              <td class="rma-print-cell rma-print-value" colspan="2">{{ disp(order.responsiblePerson) }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">批次数量</td>
              <td class="rma-print-cell rma-print-value">{{ fmtNum(order.batchQuantity) }}</td>
              <td class="rma-print-cell rma-print-label">不合格数量</td>
              <td class="rma-print-cell rma-print-value" colspan="4">{{ fmtNum(order.nonConformingQuantity) }}</td>
            </tr>
            <tr class="rma-print-tall-row">
              <td class="rma-print-cell rma-print-label rma-print-valign">不合格情况描述<br>及图片：</td>
              <td colspan="6" class="rma-print-cell rma-print-desc">
                <div v-for="(fb, fi) in feedBackLines" :key="'fb-' + fi + '-' + (fb.id || fb.feedBackId)" class="rma-print-fb-block">
                  <div v-if="(fb.problemDescription || fb.ProblemDescription || '').toString().trim()" class="rma-print-fb-text">
                    <template v-if="feedBackLines.length > 1">【项{{ fi + 1 }}】</template>
                    {{ (fb.problemDescription || fb.ProblemDescription || '').toString().trim() }}
                  </div>
                  <div v-if="picsOf(fb).length" class="rma-print-fb-pics">
                    <img v-for="(pic, pi) in picsOf(fb)" :key="'p-' + fi + '-' + pi" class="rma-print-line-img" :src="imgUrl(pic)" alt="" />
                  </div>
                </div>
                <span v-if="!feedBackLines.length"></span>
              </td>
            </tr>
            <tr>
              <td colspan="7" class="rma-print-cell rma-print-meta">
                日期：{{ disp(qualityRowDate) }}
              </td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">确认物料状态：</td>
              <td class="rma-print-cell rma-print-value">{{ disp(order.qualityConfirmMaterialStatus) }}</td>
              <td class="rma-print-cell rma-print-label">确认不合格数量</td>
              <td class="rma-print-cell rma-print-value">{{ fmtNum(order.qualityConfirmNonConformingQuantity) }}</td>
              <td class="rma-print-cell rma-print-label">确认发货数量</td>
              <td class="rma-print-cell rma-print-value" colspan="2">{{ fmtNum(order.qualityConfirmShipQuantity) }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">拍照：</td>
              <td class="rma-print-cell rma-print-photos rma-print-value">
                <img v-for="(pic, qi) in qualityPhotos" :key="'qph-' + qi" class="rma-print-thumb" :src="imgUrl(pic)" alt="" />
                <span v-if="!qualityPhotos.length"></span>
              </td>
              <td class="rma-print-cell rma-print-label">填写人</td>
              <td class="rma-print-cell rma-print-value">{{ qualityFillUser }}</td>
              <td class="rma-print-cell rma-print-label">填写日期</td>
              <td class="rma-print-cell rma-print-value" colspan="2">{{ qualityFillTime }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">处置结论：</td>
              <td colspan="6" class="rma-print-cell rma-print-value">
                <label class="rma-print-cb check"><input type="checkbox" :checked="isQualityConclusion(1)" disabled />让步接收</label>
                <label class="rma-print-cb check"><input type="checkbox" :checked="isQualityConclusion(2)" disabled />退回物料</label>
              </td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">工艺人员：</td>
              <td colspan="6" class="rma-print-cell rma-print-value">{{ engineeringPersonName }}</td>
            </tr>
            <tr class="rma-print-tall-row">
              <td class="rma-print-cell rma-print-label rma-print-valign">临时处理方案</td>
              <td colspan="6" class="rma-print-cell rma-print-desc">{{ temporaryPlansText }}</td>
            </tr>
            <!-- 下半：与上共用 7 列，打印分页 -->
            <tr class="rma-print-page-split">
              <td class="rma-print-cell rma-print-label">工艺处置结论：</td>
              <td colspan="6" class="rma-print-cell rma-print-value">
                <label v-for="o in engineeringOptions" :key="'eng-' + o.value" class="rma-print-cb check">
                  <input type="checkbox" :checked="order.engineeringDisposalConclusionType === o.value" disabled />{{ o.text }}
                </label>
                <span v-if="!engineeringOptions.length"></span>
              </td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">责任判定</td>
              <td class="rma-print-cell rma-print-label">责任单位/部门：</td>
              <td class="rma-print-cell rma-print-value">{{ liabilityUnit }}</td>
              <td class="rma-print-cell rma-print-label">责任人</td>
              <td class="rma-print-cell rma-print-value">{{ liabilityPerson }}</td>
              <td class="rma-print-cell rma-print-label">不良类别</td>
              <td class="rma-print-cell rma-print-value">{{ liabilityCategoryText }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">客户签字</td>
              <td class="rma-print-cell rma-print-label">发货数量</td>
              <td class="rma-print-cell rma-print-value">{{ customerShipQty }}</td>
              <td class="rma-print-cell rma-print-label">客户签字</td>
              <td class="rma-print-cell rma-print-value" colspan="3">{{ customerSignPlaceholder }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">现场确认状态</td>
              <td class="rma-print-cell rma-print-label">数量</td>
              <td class="rma-print-cell rma-print-value">{{ onsiteQty }}</td>
              <td class="rma-print-cell rma-print-label">状态+拍照</td>
              <td class="rma-print-cell rma-print-photo-cell rma-print-value">
                <img v-for="(pic, oi) in onsitePics" :key="'os-' + oi" class="rma-print-thumb" :src="imgUrl(pic)" alt="" />
                <span v-if="!onsitePics.length"></span>
              </td>
              <td class="rma-print-cell rma-print-label">操作人</td>
              <td class="rma-print-cell rma-print-value">{{ onsiteOperator }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">客退品仓入库</td>
              <td class="rma-print-cell rma-print-label">数量</td>
              <td class="rma-print-cell rma-print-value">{{ warehouseQty }}</td>
              <td class="rma-print-cell rma-print-label">状态+拍照</td>
              <td class="rma-print-cell rma-print-photo-cell rma-print-value">
                <img v-for="(pic, wi) in warehousePics" :key="'wh-' + wi" class="rma-print-thumb" :src="imgUrl(pic)" alt="" />
                <span v-if="!warehousePics.length"></span>
              </td>
              <td class="rma-print-cell rma-print-label">操作人</td>
              <td class="rma-print-cell rma-print-value">{{ warehouseOperator }}</td>
            </tr>
            <tr>
              <td rowspan="2" class="rma-print-cell rma-print-label rma-print-valign">退货处理完成<br>（工单关闭）</td>
              <td class="rma-print-cell rma-print-label">补货处理</td>
              <td colspan="3" class="rma-print-cell rma-print-value">{{ replenishmentPair }}</td>
              <td class="rma-print-cell rma-print-label">操作人</td>
              <td class="rma-print-cell rma-print-value">{{ replenishmentOperator }}</td>
            </tr>
            <tr>
              <td class="rma-print-cell rma-print-label">退货处理</td>
              <td colspan="3" class="rma-print-cell rma-print-value">{{ returnPair }}</td>
              <td class="rma-print-cell rma-print-label">操作人</td>
              <td class="rma-print-cell rma-print-value">{{ returnOperator }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <Button class="close-btn" @click="cancel">取消</Button>
        <Button v-print="printObj" type="primary" class="close-btn" :disabled="!order">打印</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getOnsiteConfirmMaterialFilesArray,
  getReturnWarehouseInFilesArray,
  rmaPickFirstNum,
} from '../rmaWorkflowSegmentUtils'

const API = '/api/services/app/RMA_Order'

/**
 * GetOrderDetail 打印映射说明（缺口由业务确认是否补字段）：
 * - 联次「第一联/第二联」：无字段，仅占位
 * - 固定模板编号 FORM_TEMPLATE_CODE 与 formNumber 并存策略
 * - 「日期」单独行：暂用 salesFillTimeText / occurrenceTimeText
 * - 「客户签字」第二处：无独立签章字段，显示 —
 */
const FORM_TEMPLATE_CODE = 'JL-PZ-FORM-027/A0'

export default {
  name: 'RMAOrderPrint',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    infoData: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formTemplateCode: FORM_TEMPLATE_CODE,
      loading: false,
      order: null,
      initOptions: {
        causeDepartments: [],
        engineeringDisposalConclusions: [],
        liabilityDefectCategories: [],
      },
      printObj: {
        id: 'PrintArea',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        openCallback() {},
        closeCallback() {},
      },
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    baseUrl() {
      return this.$constDefinition.baseUrl
    },
    feedBackLines() {
      const o = this.order
      if (!o) return []
      const raw = o.feedBacks || o.feedBackLines
      return Array.isArray(raw) ? raw : []
    },
    engineeringOptions() {
      return this.initOptions.engineeringDisposalConclusions || []
    },
    causeDeptText() {
      const o = this.order
      if (!o) return ''
      if (o.causeDepartmentText && String(o.causeDepartmentText).trim()) {
        return String(o.causeDepartmentText).trim()
      }
      const v = o.causeDepartment
      const list = this.initOptions.causeDepartments || []
      const hit = list.find((x) => x.value === v)
      return hit ? hit.text : v != null && v !== '' ? String(v) : ''
    },
    qualityPhotos() {
      const o = this.order
      if (!o) return []
      const raw = o.qualityPhotoFiles || o.QualityPhotoFiles
      return Array.isArray(raw) ? raw : []
    },
    qualityFillUser() {
      const o = this.order
      if (!o) return ''
      const d = o
      for (const k of ['qualitySubmitterName', 'QualitySubmitterName']) {
        if (d[k] != null && String(d[k]).trim()) return String(d[k]).trim()
      }
      const v =
        d.qualityConfirmUserName ||
        d.qualityConfirmFillUserName ||
        d.qualityConfirmationUserName ||
        d.qualityDepartmentConfirmUserName ||
        d.qualityConfirmSubmitterName ||
        d.qualityFillUserName
      return v != null && String(v).trim() ? String(v).trim() : ''
    },
    qualityFillTime() {
      const o = this.order
      if (!o) return ''
      const d = o
      for (const k of ['qualityFillDateText', 'QualityFillDateText']) {
        const raw = d[k]
        if (raw != null && raw !== '') {
          if (typeof raw === 'string') return raw
          if (raw && raw.toString) return raw.toString()
          return String(raw)
        }
      }
      const t =
        d.qualityConfirmTime ||
        d.qualityConfirmationTime ||
        d.qualityDepartmentConfirmTime ||
        d.qualityFillTime ||
        d.qualityConfirmCreationTime
      if (t == null || t === '') return ''
      if (typeof t === 'string') return t
      if (t && t.toString) return t.toString()
      return String(t)
    },
    /** GAP：图1「日期」行 */
    qualityRowDate() {
      const o = this.order
      if (!o) return ''
      if (o.salesFillTimeText && String(o.salesFillTimeText).trim())
        return String(o.salesFillTimeText)
      if (o.occurrenceTimeText) return String(o.occurrenceTimeText)
      return ''
    },
    engineeringPersonName() {
      const o = this.order
      if (!o) return ''
      const d = o
      for (const k of ['EngineeringPersonName', 'engineeringPersonName']) {
        if (d[k] != null && String(d[k]).trim()) return String(d[k]).trim()
      }
      return ''
    },
    temporaryPlansText() {
      const o = this.order
      if (!o) return ''
      const fbs = this.feedBackLines
      const fromRows = []
      const rawPlans = o.feedBackTreatmentPlans || o.FeedBackTreatmentPlans
      if (Array.isArray(rawPlans) && rawPlans.length && fbs.length) {
        rawPlans.forEach((p) => {
          const fbId = p.feedBackId != null ? p.feedBackId : p.FeedBackId
          const fi = fbs.findIndex((f) => {
            const rawId =
              f.id != null ? f.id : f.feedBackId != null ? f.feedBackId : f.feedBackLineId
            return Number(rawId) === Number(fbId)
          })
          const planRaw =
            p.temporaryTreatmentPlan != null ? p.temporaryTreatmentPlan : p.TemporaryTreatmentPlan
          const planStr = planRaw != null && String(planRaw).trim() ? String(planRaw).trim() : ''
          if (fi >= 0) {
            fromRows.push(fbs.length > 1 ? `【不合格项${fi + 1}】${planStr}` : planStr)
          }
        })
        if (fromRows.length) return fromRows.join('\n')
      }
      const fallback = []
      fbs.forEach((fb, fi) => {
        const plan =
          fb.temporaryTreatmentPlan ||
          fb.TemporaryTreatmentPlan ||
          fb.engineeringTemporaryTreatmentPlan ||
          ''
        if (plan != null && String(plan).trim()) {
          fallback.push(
            fbs.length > 1 ? `【不合格项${fi + 1}】${String(plan).trim()}` : String(plan).trim()
          )
        }
      })
      if (fallback.length) return fallback.join('\n')
      const legacy = o.temporaryTreatmentPlan
      return legacy != null && String(legacy).trim() ? String(legacy).trim() : ''
    },
    liabilityUnit() {
      const o = this.order
      if (!o) return ''
      const v = o.liabilityUnitOrDept != null ? o.liabilityUnitOrDept : o.LiabilityUnitOrDept
      return v != null && String(v).trim() ? String(v).trim() : ''
    },
    liabilityPerson() {
      const o = this.order
      if (!o) return ''
      const v = o.liabilityPerson != null ? o.liabilityPerson : o.LiabilityPerson
      return v != null && String(v).trim() ? String(v).trim() : ''
    },
    liabilityCategoryText() {
      const o = this.order
      if (!o) return ''
      const text =
        o.liabilityDefectCategoryTypeText != null
          ? o.liabilityDefectCategoryTypeText
          : o.LiabilityDefectCategoryTypeText
      if (text != null && String(text).trim()) return String(text).trim()
      const t =
        o.liabilityDefectCategoryType !== undefined && o.liabilityDefectCategoryType !== null
          ? o.liabilityDefectCategoryType
          : o.LiabilityDefectCategoryType
      if (t === null || t === undefined || t === '') return ''
      return this.selText(this.initOptions.liabilityDefectCategories, t) || String(t)
    },
    customerShipQty() {
      const o = this.order
      if (!o) return ''
      const q = rmaPickFirstNum(o, ['qualityConfirmShipQuantity', 'QualityConfirmShipQuantity'])
      return q !== null && !Number.isNaN(q) ? String(q) : ''
    },
    /** GAP：客户签字栏无独立字段 */
    customerSignPlaceholder() {
      return ''
    },
    onsiteQty() {
      const o = this.order
      if (!o) return ''
      const q = rmaPickFirstNum(o, [
        'onsiteConfirmQuantity',
        'OnsiteConfirmQuantity',
        'onSiteConfirmationQuantity',
        'OnSiteConfirmQuantity',
      ])
      return q !== null && !Number.isNaN(q) ? String(q) : ''
    },
    onsitePics() {
      return this.order ? getOnsiteConfirmMaterialFilesArray(this.order) : []
    },
    onsiteOperator() {
      return this.pickStr(['onsiteOperatorName', 'OnsiteOperatorName'])
    },
    warehouseQty() {
      const o = this.order
      if (!o) return ''
      const q = rmaPickFirstNum(o, [
        'returnWarehouseInQuantity',
        'ReturnWarehouseInQuantity',
        'warehouseInboundQuantity',
      ])
      return q !== null && !Number.isNaN(q) ? String(q) : ''
    },
    warehousePics() {
      return this.order ? getReturnWarehouseInFilesArray(this.order) : []
    },
    warehouseOperator() {
      return this.pickStr(['warehouseInOperatorName', 'WarehouseInOperatorName'])
    },
    replenishmentPair() {
      const o = this.order
      if (!o) return ''
      const q = rmaPickFirstNum(o, [
        'replenishmentQuantity',
        'replenishmentProcessQuantity',
        'ReplenishmentQuantity',
      ])
      const qty = q !== null && !Number.isNaN(q) ? String(q) : ''
      let dateText = ''
      for (const k of [
        'replenishmentCompleteDate',
        'replenishmentProcessCompleteDate',
        'ReplenishmentCompleteDate',
      ]) {
        if (!Object.prototype.hasOwnProperty.call(o, k)) continue
        const raw = o[k]
        if (raw == null || raw === '') continue
        dateText =
          typeof raw === 'string' && raw.length >= 10 ? raw.trim().slice(0, 10) : String(raw)
        break
      }
      if (typeof this.$moment === 'function' && o.replenishmentCompletedTime) {
        const m = this.$moment(o.replenishmentCompletedTime)
        if (m.isValid()) dateText = m.format('YYYY-MM-DD')
      }
      return `${qty}  ${dateText}`
    },
    replenishmentOperator() {
      return this.pickStr(['replenishmentOperatorName', 'ReplenishmentOperatorName'])
    },
    returnPair() {
      const o = this.order
      if (!o) return ''
      const q = rmaPickFirstNum(o, [
        'returnQuantity',
        'ReturnQuantity',
        'returnProcessQuantity',
        'ReturnProcessQuantity',
      ])
      const qty = q !== null && !Number.isNaN(q) ? String(q) : ''
      let dateText = ''
      for (const k of [
        'returnProcessCompleteDate',
        'returnHandlingCompleteDate',
        'ReturnProcessCompleteDate',
      ]) {
        if (!Object.prototype.hasOwnProperty.call(o, k)) continue
        const raw = o[k]
        if (raw == null || raw === '') continue
        dateText =
          typeof raw === 'string' && raw.length >= 10 ? raw.trim().slice(0, 10) : String(raw)
        break
      }
      if (typeof this.$moment === 'function' && o.returnCompletedTime) {
        const m = this.$moment(o.returnCompletedTime)
        if (m.isValid()) dateText = m.format('YYYY-MM-DD')
      }
      return `${qty}  ${dateText}`
    },
    returnOperator() {
      return this.pickStr(['returnOperatorName', 'ReturnOperatorName'])
    },
  },
  watch: {
    value(v) {
      if (v && this.infoData != null) this.loadAll()
    },
    infoData() {
      if (this.value && this.infoData != null) this.loadAll()
    },
  },
  mounted() {
    if (this.value && this.infoData != null) this.loadAll()
  },
  methods: {
    parseAbpData(httpBody) {
      if (httpBody == null) return null
      if (Object.prototype.hasOwnProperty.call(httpBody, 'result')) return httpBody.result
      return httpBody
    },
    disp(v) {
      if (v == null || v === '') return ''
      return String(v)
    },
    fmtNum(v) {
      if (v === null || v === undefined || v === '') return ''
      return String(v)
    },
    selText(list, value) {
      if (!list || value == null) return ''
      const f = list.find((x) => x.value === value)
      return f ? f.text : ''
    },
    pickStr(candidates) {
      const o = this.order
      if (!o) return ''
      for (let i = 0; i < candidates.length; i++) {
        const k = candidates[i]
        if (!Object.prototype.hasOwnProperty.call(o, k)) continue
        const v = o[k]
        if (v != null && String(v).trim()) return String(v).trim()
      }
      return ''
    },
    picsOf(fb) {
      const raw = fb.pictureFiles || fb.PictureFiles
      return Array.isArray(raw) ? raw : []
    },
    imgUrl(pic) {
      if (!pic) return ''
      const path =
        (pic.url != null && pic.url !== '' ? pic.url : '') ||
        (pic.imageUrl != null && pic.imageUrl !== '' ? pic.imageUrl : '') ||
        (pic.filePath != null && pic.filePath !== '' ? pic.filePath : '') ||
        (pic.guid ? `/files/previewThumbnail/${pic.guid}` : '') ||
        (pic.fileGuids ? `/files/previewThumbnail/${pic.fileGuids}` : '')
      if (!path) return ''
      const s = String(path).trim()
      if (
        /^https?:\/\//i.test(s) ||
        s.startsWith('//') ||
        s.startsWith('blob:') ||
        s.startsWith('data:')
      ) {
        return s
      }
      return this.baseUrl + (s.startsWith('/') ? s : `/${s}`)
    },
    isQualityConclusion(val) {
      const o = this.order
      if (!o) return false
      const t = o.qualityDisposalConclusionType
      return Number(t) === Number(val)
    },
    async loadAll() {
      this.loading = true
      this.order = null
      try {
        const [initRes, detailRes] = await Promise.all([
          this.$Ajax.get(`${API}/GetMgrInitData`),
          this.$Ajax.get(`${API}/GetOrderDetail`, { params: { id: this.infoData } }),
        ])
        const initR = this.parseAbpData(initRes.data) || {}
        this.initOptions = {
          causeDepartments: initR.causeDepartments || [],
          engineeringDisposalConclusions: initR.engineeringDisposalConclusions || [],
          liabilityDefectCategories:
            initR.liabilityDefectCategories || initR.LiabilityDefectCategories || [],
        }
        this.order = this.parseAbpData(detailRes.data)
      } catch (e) {
        this.$Message.error('加载打印数据失败')
        this.order = null
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.$emit('input', false)
      this.$emit('succesConfirm', false)
    },
    onModalVisibleChange(visible) {
      if (!visible) {
        this.$emit('input', false)
        this.$emit('succesConfirm', false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
@media print {
  #PrintArea {
    display: block;
    height: auto;
    overflow: visible;
  }
  tr.rma-print-page-split td {
    page-break-before: always;
    break-before: page;
  }
}

#PrintArea {
  box-sizing: border-box;
  color: #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 12px;
  padding: 0 20px;
}

.rma-print-empty {
  padding: 24px;
  text-align: center;
  color: #999;
}

.rma-print-table-root {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  border: 1px solid #000;
}

/* 整张表统一 7 列宽，与现场确认/客退等行一致（原 6 列 + 7 列双表会造成竖线错位、接缝双线变粗） */
.rma-col-g1 {
  width: 12%;
}
.rma-col-g2 {
  width: 12%;
}
.rma-col-g3 {
  width: 12%;
}
.rma-col-g4 {
  width: 12%;
}
.rma-col-g5 {
  width: 20%;
}
.rma-col-g6 {
  width: 12%;
}
.rma-col-g7 {
  width: 20%;
}

.rma-print-cell,
.rma-print-table-root th {
  border: 1px solid #000;
  box-sizing: border-box;
  font-size: 12px;
  min-height: 30px;
  padding: 4px 6px;
  vertical-align: middle;
}

.rma-print-label {
  text-align: left;
  white-space: nowrap;
}

.rma-print-value {
  text-align: left;
  word-break: break-word;
}

.rma-print-meta {
  text-align: left;
  padding-left: 10px;
}

.rma-print-title {
  font-weight: 400;
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  border: 0 none !important;
  vertical-align: middle;
  text-align: center;
}

.rma-print-company {
  font-size: 20px;
  text-align: center;
}

.rma-print-valign {
  vertical-align: middle;
}

.rma-print-desc {
  text-align: left;
  vertical-align: top;
  min-height: 80px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  padding-left: 5px;
}

.rma-print-tall-row td {
  vertical-align: top;
}

.rma-print-photo-cell {
  text-align: left;
  vertical-align: middle;
}

.rma-print-fb-block {
  margin-bottom: 8px;
}

.rma-print-fb-text {
  margin-bottom: 4px;
}

.rma-print-fb-pics {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.rma-print-line-img,
.rma-print-thumb {
  max-width: 80px;
  max-height: 80px;
  object-fit: contain;
  border: 1px solid #ccc;
  vertical-align: middle;
}

.rma-print-photos img {
  vertical-align: middle;
  margin-right: 4px;
}

.rma-print-cb {
  margin: 0 10px 0 0;
  white-space: nowrap;
}

.text-copy-row .chk-w {
  margin: 0 4px;
}

/* 与 UnacceptedProductProcessOrders/print.vue：弹窗与顶栏 */
/deep/.printModal .ivu-modal {
  top: 0;
}

/deep/.printModal .ivu-modal-header-inner {
  font-size: 20px;
  text-align: center;
}

.printModal /deep/ .ivu-modal-footer > div {
  text-align: center;
}

input[type='checkbox'] {
  width: 12px;
  height: 12px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 12px;
  position: relative;
  margin-right: 5px;
}

input[type='checkbox']::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #cacdcf;
}

input[type='checkbox']:checked::before {
  content: '\2713';
  background-color: #000;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px solid #000;
  font-size: 12px;
  font-weight: bold;
}
</style>
